// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__EwVYi","footerSegment":"Footer_footerSegment__jP3on"};